import axios from 'axios'

const api = axios.create({
  baseURL: 'https://6aa94ae82d442cb69d49a27d.mockapi.io',
  timeout: 5000
})

export default api